import script from "./CartDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./CartDrawer.vue?vue&type=script&setup=true&lang=js"

import "./CartDrawer.vue?vue&type=style&index=0&id=42846fb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42846fb4"]])

export default __exports__